export default __webpack_public_path__ + "static/media/visa.8bfc7b48.svg";